import {DeviceListScreen} from './DeviceListScreen';
import {RouteDefinition} from '../../../routes';
import {DeviceEditScreen} from './DeviceEditScreen';
import {DeviceSettingsScreen} from './DeviceSettingsScreen';
import {BoosterDeviceListScreen} from './BoosterDeviceList';
import {BoosterDeviceEditScreen} from './BoosterEditList';
import {DetailedRfTest} from './DetailedRfTest';

export const DeviceSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/device/edit',
        component: DeviceEditScreen,
    },
    {
        routerLink: '/settings/device/edit/:id',
        component: DeviceEditScreen,
    },
    {
        routerLink: '/settings/device/device-settings/:id',
        component: DeviceSettingsScreen,
    },
    {
        routerLink: '/settings/device',
        component: DeviceListScreen,
    },
    {
        routerLink: '/settings/device/booster-list/:id',
        component: BoosterDeviceListScreen,
    },
    {
        routerLink: '/settings/device/booster-list/:id/add',
        component: BoosterDeviceEditScreen,
    },
    {
        routerLink: "/settings/device/device-settings/:id/detailed-rf-test/:gatewayId",
        component: DetailedRfTest
    }
];
